/**
 * La clé correspond au nom d'une route et sa valeur est un tableau d'object correspondant à un group via sa reference et un tableau d'access necessaire pour accéder à cette route
 */
export default {
  'list-user': [
    {
      groupReference: '_super_admin',
      access: ['1'],
    },
    {
      groupReference: '_admin',
      access: ['3'],
    },
    {
      groupReference: '_in_charge',
      access: ['3'],
    },
    {
      groupReference: '_compta',
      access: ['1'],
    },
  ],
  'leave-request-manager': [
    {
      groupReference: '_super_admin',
      access: ['1'],
    },
    {
      groupReference: '_admin',
      access: ['3'],
    },
    {
      groupReference: '_in_charge',
      access: ['3'],
    },
    {
      groupReference: '_compta',
      access: ['1'],
    },
  ],
  'add-user': [
    {
      groupReference: '_super_admin',
      access: ['1'],
    },
    {
      groupReference: '_admin',
      access: ['1'],
    },
    {
      groupReference: '_in_charge',
      access: ['1'],
    },
  ],
  'edit-user': [
    {
      groupReference: '_super_admin',
      access: ['1'],
    },
    {
      groupReference: '_admin',
      access: ['2'],
    },
    {
      groupReference: '_in_charge',
      access: ['2'],
    },
  ],
  'account-profile': [
    {
      groupReference: '_super_admin',
      access: ['1'],
    },
    {
      groupReference: '_admin',
      access: ['1', '2', '3'],
    },
    {
      groupReference: '_in_charge',
      access: ['1', '2', '3'],
    },
  ],
  structures: [
    {
      groupReference: '_super_admin',
      access: ['1'],
    },
  ],
  'menu.direction': [
    {
      groupReference: '_super_admin',
      access: ['1'],
    },
  ],
  'menu.attendance.io': [
    {
      groupReference: '_super_admin',
      access: ['1'],
    },
    {
      groupReference: '_admin',
      access: ['1'],
    },
    {
      groupReference: '_in_charge',
      access: ['1', '2', '3'],
    },
    {
      groupReference: '_compta',
      access: ['1'],
    },
  ],
  'menu.dailyReportManagerView': [
    {
      groupReference: '_super_admin',
      access: ['1'],
    },
    {
      groupReference: '_in_charge',
      access: ['1', '2', '3'],
    },
  ],
  'menu.taskManagerView': [
    {
      groupReference: '_super_admin',
      access: ['1'],
    },
    {
      groupReference: '_in_charge',
      access: ['1', '2', '3'],
    },
  ],
  'days-off-answer': [
    {
      groupReference: '_super_admin',
      access: ['1'],
    },
    {
      groupReference: '_in_charge',
      access: ['1', '2', '3'],
    },
    {
      groupReference: '_compta',
      access: ['1'],
    },
  ],
  medicalLeave: [
    {
      groupReference: '_compta',
      access: ['1'],
    },
    {
      groupReference: '_super_admin',
      access: ['1'],
    },
  ],
  'minibus-request-manage': [
    {
      groupReference: '_super_admin',
      access: ['1', '2', '3'],
    },
    {
      groupReference: '_receptionist',
      access: ['1', '2', '3'],
    },
    {
      groupReference: '_minibus_admin',
      access: ['1', '2', '3'],
    },
  ],
  'regie-request-management': [
    {
      groupReference: '_super_admin',
      access: ['1', '2', '3'],
    },
    {
      groupReference: '_in_charge',
      access: ['1', '2', '3'],
    },
    {
      groupReference: '_compta',
      access: ['1', '2', '3'],
    },
  ],
};
